import { FC } from "react";
import { CircularProgress as MdCircularProgress } from "@rmwc/circular-progress";
import "@rmwc/circular-progress/styles";
import { Size } from "../../..";

export type CircularProgressTypes = {
  size?: Size;
};

const CircularProgress: FC<CircularProgressTypes> = (props) => {
  const { size } = props;

  return <MdCircularProgress size={size} />;
};

export default CircularProgress;
